import type { IconButtonProps } from '@src/shared/ui/Button';
import { ArrowLeftIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import NavIconButton from './NavIconButton';

const PrevIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <NavIconButton ref={ref} {...props}>
        <ArrowLeftIcon />
      </NavIconButton>
    );
  },
);

export default PrevIconButton;
